import { torontoDate } from "../domain/time/toronto";

/** Report query key for the Classement; "Ma journée" and the card share it, so today is fetched once. */
export const leaderboardKey = (period: string, now: Date) => [
  "leaderboard",
  period,
  torontoDate(now),
];
